import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Button from 'react-bootstrap/Button';
import moment from 'moment';
import Ticker from "./Ticker";
import TickerList from "./TickerList";
import CalendarAnimatedList from "./CalendarAnimatedList";
import TickerTask from "./TickerTask";
import ProcastGoalsPanel from './ProcastGoalsPanel';

import './ProcastTipsOverlay.css';

const SLIDE_DURATION_MS = 5000;
const SLIDE_FADE_DURATION_MS = 1000;

const ProcastTipsOverlay = React.memo(({
    show,
    goals = [],
    allTodos,
    allTodosOriginal,
    todoRefreshFlagHandler,
    onlyXDaysFromNow,
    setOnlyXDaysFromNow,
    onClose,
    currentTime,
    tasksToShowOnProcast,
    loadTaskHandler
}) => {
    const [showKpiGoals, setShowKpiGoals] = useState(false);
    const [kpiGoalsVisible, setKpiGoalsVisible] = useState(false);

    useEffect(() => {
        if (!show) {
            setShowKpiGoals(false);
            setKpiGoalsVisible(false);
        }
    }, [show]);

    const currentGoals = useMemo(() => goals.filter((goal) => goal.progress?.current), [goals]);
    const showGoalsAfterTodos = useCallback(() => {
        if (currentGoals.length > 0) {
            setKpiGoalsVisible(false);
            setShowKpiGoals(true);
        }
    }, [currentGoals.length]);

    useEffect(() => {
        if (!showKpiGoals) return undefined;
        const fadeInTimer = window.setTimeout(() => setKpiGoalsVisible(true), 20);
        const fadeOutTimer = window.setTimeout(
            () => setKpiGoalsVisible(false),
            SLIDE_DURATION_MS - SLIDE_FADE_DURATION_MS
        );
        const finishTimer = window.setTimeout(() => setShowKpiGoals(false), SLIDE_DURATION_MS);
        return () => {
            window.clearTimeout(fadeInTimer);
            window.clearTimeout(fadeOutTimer);
            window.clearTimeout(finishTimer);
        };
    }, [showKpiGoals]);

    if (!show) return null;

    return (
        <div className={`AppV AppOverlay AppOverlayTodos`}>
            <div className="OverlayLeftColumn">
                {showKpiGoals ? (
                    <ProcastGoalsPanel goals={currentGoals} visible={kpiGoalsVisible} />
                ) : (
                    <div>
                        <div className='Label' style={{ marginTop: 0, fontWeight: 'bold', fontSize: 16, marginBottom: 12}}>YOUR GOALS</div>
                        <div>
                            { /* Display todos starting with * */ }
                            <Ticker data={allTodos}></Ticker>
                        </div>
                        <div className='Label' style={{ fontWeight: 'bold', fontSize: 16, marginBottom: 12, marginTop: 12}}>ALSO ON YOUR SCHEDULE</div>
                        <div className="procast-todo-list-slot">
                            <TickerList
                                todoRefreshFlagHandler={todoRefreshFlagHandler}
                                dataOriginal={allTodosOriginal}
                                data={allTodos}
                                nItems={3}
                                onlyXDaysFromNow={onlyXDaysFromNow}
                                onCycleComplete={currentGoals.length > 0 ? showGoalsAfterTodos : undefined}
                            ></TickerList>
                        </div>

                        {/* <ul>
                        {allTodos && allTodos.map((td) => {
                            if (!td.content.startsWith('*'))
                            {
                                let daysUntil = moment(td.deferUntil).diff(moment(), 'days')
                                return(<li>{td.content} {td.hasOwnProperty('deferUntil') ? ' (' + moment(td.deferUntil).format('D/MM') + ' | ' + daysUntil +  'd)' : ''}</li>)
                            }
                        })}
                        </ul> */}
                        <div className="ProcastButtons" style={{display: 'flex', flexDirection: 'row', marginTop: 16}}>
                            <Button variant='dark' size="sm" onClick={onClose} style={{marginRight: 2}}>OK</Button>
                            <Button variant={`${onlyXDaysFromNow === 9999 ? 'primary' : 'dark'}`} onClick={() => {setOnlyXDaysFromNow(9999)}} size="sm">ALL</Button>
                            <Button variant={`${onlyXDaysFromNow === 3 ? 'primary' : 'dark'}`} onClick={() => {setOnlyXDaysFromNow(3)}} size="sm">3</Button>
                            <Button variant={`${onlyXDaysFromNow === 7 ? 'primary' : 'dark'}`} onClick={() => {setOnlyXDaysFromNow(7)}} size="sm">7</Button>
                            <Button variant={`${onlyXDaysFromNow === 14 ? 'primary' : 'dark'}`} onClick={() => {setOnlyXDaysFromNow(14)}} size="sm">14</Button>
                            <Button variant={`${onlyXDaysFromNow === 31 ? 'primary' : 'dark'}`} onClick={() => {setOnlyXDaysFromNow(31)}} size="sm">31</Button>
                        </div>
                    </div>
                )}
            </div>

            <div className="OverlayRightColumn">
                <div>
                    <div className='Label' style={{ fontWeight: 'bold', fontSize: 16, marginBottom: 12, marginTop: 0}}>UPCOMING</div>
                    <CalendarAnimatedList 
                        nItemsDisplay={2} 
                        maxCalendarItems={5} 
                        todayOnly={true} 
                        currentTime={moment(currentTime)}
                    ></CalendarAnimatedList>
                </div>
                <div>
                    <div className='Label' style={{ fontWeight: 'bold', fontSize: 16, marginBottom: 12, marginTop: 0}}>OTHER TASKS</div>
                    <TickerTask 
                        tasksToShowOnProcast={tasksToShowOnProcast} 
                        loadTaskHandler={loadTaskHandler}
                    ></TickerTask>
                </div>
            </div>
        </div>
    );
});

ProcastTipsOverlay.displayName = 'ProcastTipsOverlay';

export default ProcastTipsOverlay;
